import { scrollTo } from './lenis'

/**
 * Wraps the elements of an array.
 * @param {Array} arr - the array of elements to be wrapped
 * @param {String} wrapType - the type of the wrap element ('div', 'span' etc)
 * @param {String} wrapClass - the wrap class(es)
 */

export const WrapLines = (arr, wrapType, wrapClass) => {
  arr.forEach((el) => {
    const wrapEl = document.createElement(wrapType)
    wrapEl.classList = wrapClass
    el.parentNode.appendChild(wrapEl)
    wrapEl.appendChild(el)
  })
}

export const isSafariBrowser = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export const isFirefoxBrowser = () => {
  return navigator.userAgent.toLowerCase().includes('firefox');
}

export const debounce = (func, delay) => {
  let timeoutId
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export const setHeaderColour = (container) => {
	document.documentElement.setAttribute('data-header-theme', container.dataset.header)
}

export const refreshScripts = (container) => {
	const scripts = container.querySelectorAll('main script')
	scripts.forEach((script) => {
    eval(script.innerHTML) 
  })
}

export const refreshTrustpilotWidget = (container) => {
  const trustpilot = container.querySelector('.trustpilot-widget')
  if (!trustpilot) return
  window.Trustpilot.loadFromElement(trustpilot)
}

export const autoplayVideos = (container) => {
  const videos = container.querySelectorAll('video[autoplay]')
  videos.forEach((video) => video.play())
}

export const setTheme = () => {
	let theme = localStorage.getItem('theme')
	const html = document.documentElement
	const toggles = document.querySelectorAll('[data-theme-toggle]')
	
	if (theme === null) {
		const darkPreference = window.matchMedia('(prefers-color-scheme: dark)')
	
		if (darkPreference.matches) {
			theme = 'dark'
			html.dataset.theme = 'dark'
			localStorage.setItem('theme', 'dark')
		} else {
			theme = 'light'
			html.dataset.theme = 'light'
			localStorage.setItem('theme', 'light')
		}
	} else {
		theme = theme
		html.dataset.theme = theme
		localStorage.setItem('theme', theme)
	}

	toggles.forEach(toggle => {
		toggle.addEventListener('click', () => {
			if (theme == 'light') {
				theme = 'dark'
				html.dataset.theme = 'dark'
				localStorage.setItem('theme', 'dark')
			} else {
				theme = 'light'
				html.dataset.theme = 'light'
				localStorage.setItem('theme', 'light')
			}
		})
	})
}

export const pxToRem = (px) => {
	const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
	return px / rootFontSize;
}

export const generateContentsList = () => {
	let html = ''
	const el = document.querySelector('[data-article]')

	if (!el) return

	const headings = el?.querySelectorAll('[data-article-content] h2')
	const contents = el?.querySelector('[data-article-contents] ul')

	headings.forEach((heading, i) => {
		heading.id = `heading-${i}`
		html += `<li><a class="font-body-s" href="#" data-scroll-to="#heading-${i}" data-scroll-offset="-175">${ heading.innerHTML }</a></li>`
	})

	contents.innerHTML = html

	scrollTo()
}

export const setHeaderWidth = () => {
	const header = document.querySelector('.header')
	const headerInner = header.querySelector('.header__inner')

	headerInner.style.width = `${pxToRem(headerInner.offsetWidth)}rem`
	headerInner.dataset.width = `${headerInner.offsetWidth}`

	let windowWidth = window.innerWidth

	const handleResize = () => {
		if (windowWidth != window.innerWidth) {
			if (document.documentElement.dataset.scrolled == 'true') {
				header.classList.add('width-auto')
				setTimeout(() => {
					headerInner.style.cssText = ''
					headerInner.dataset.width = ''
					headerInner.style.width = `${pxToRem(headerInner.offsetWidth)}rem`
					headerInner.dataset.width = `${headerInner.offsetWidth}`
					header.classList.remove('width-auto')
					gsap.to(header, { duration: 0.3, opacity: 1, delay: 0.2 })
				}, 1000)
			} else {
				setTimeout(() => {
					headerInner.style.cssText = ''
					headerInner.dataset.width = ''
					headerInner.style.width = `${pxToRem(headerInner.offsetWidth)}rem`
					headerInner.dataset.width = `${headerInner.offsetWidth}`
					gsap.to(header, { duration: 0.3, opacity: 1 })
				}, 1000)
			}
			windowWidth = window.innerWidth
		}
	}

	const debouncedResize = debounce(handleResize, 300)
	window.addEventListener('resize', debouncedResize)
	window.addEventListener('resize', () => {
		if (windowWidth != window.innerWidth) {
			gsap.to(header, { duration: 0.3, opacity: 0 })
		}
	})
}

export const getCentreDifference = (child, parent) => {
	const childEl = child.getBoundingClientRect()
	const parentEl = parent.getBoundingClientRect()
	
	const centre1 = {
		x: childEl.left + childEl.width / 2,
		y: childEl.top + childEl.height / 2,
	}
	
	const centre2 = {
		x: parentEl.left + parentEl.width / 2,
		y: parentEl.top + parentEl.height / 2,
	}
	
	const difference = {
		x: centre1.x - centre2.x,
		y: centre1.y - centre2.y,
	}
	
	return difference
}

export const creditBgn = () => {
	console.log('%cBGN\n' + '%cBuilt by BGN Agency:\n' + '%chttps://www.bgn.agency/', 'font-family: Georgia;font-size: 3em;font-weight: bold;color: #f8bdd7;', 'font-size: 1em;color: #f8bdd7;', 'font-size: 1em;');
}

export default () => {}
